export default "__VITE_ASSET__CXN74T5q__"